import { EsignRequestStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const esignRequestStatusMessage = defineMessages({
  completed: {
    defaultMessage: 'Completed',
    description: 'e-sign request status',
  },
  declined: {
    defaultMessage: 'Declined',
    description: 'e-sign request status',
  },
  failed: {
    defaultMessage: 'Failed',
    description: 'e-sign request status',
  },
  inProgress: {
    defaultMessage: 'In progress',
    description: 'e-sign request status',
  },
  pending: {
    defaultMessage: 'Pending',
    description: 'e-sign request status',
  },
  voided: {
    defaultMessage: 'Voided',
    description: 'e-sign request status',
  },
})

export function translateEsignRequestStatus(intl: IntlShape, status: EsignRequestStatus): string {
  switch (status) {
    case EsignRequestStatus.COMPLETED:
      return intl.formatMessage(esignRequestStatusMessage.completed)
    case EsignRequestStatus.DECLINED:
      return intl.formatMessage(esignRequestStatusMessage.declined)
    case EsignRequestStatus.FAILED:
      return intl.formatMessage(esignRequestStatusMessage.failed)
    case EsignRequestStatus.IN_PROGRESS:
      return intl.formatMessage(esignRequestStatusMessage.inProgress)
    case EsignRequestStatus.PENDING:
      return intl.formatMessage(esignRequestStatusMessage.pending)
    case EsignRequestStatus.VOIDED:
      return intl.formatMessage(esignRequestStatusMessage.voided)
  }
}
